// Module
var code = "<div layout=\"column\" layout-align=\"center center\" layout-padding> <h2 class=\"md-headline\" translate>CONNECTIONLOST.TITLE</h2> <p class=\"md-subhead\" translate>CONNECTIONLOST.MESSAGE</p> <md-progress-circular md-diameter=\"96\"></md-progress-circular> </div> ";
// Exports
var _module_exports =code;;
var path = 'routes/connectionLost/connectionLost.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;